import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const WorkPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const WorkIntroductionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  margin-top: 2%;
  max-width: 1200px;

  @media (max-width: 1335px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const WorkIntroductionTextContainer = styled.div`
  flex: 1;
  text-align: center;

  @media (max-width: 1335px) {
    width: 80%;
    margin-top: 20px;
  }
`;

export const WorkIntroductionImage = styled.img`
  border-radius: 24px;
  width: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  object-fit: cover;

  @media (max-width: 1335px) {
    width: 80%;
  }
`;

export const WorkIntroductionIntroTitle = styled.h3`
  color: #3393f0;
  letter-spacing: 2px;
  font-size: 14px;
  margin-bottom: 20px;
`;

export const WorkIntroductionTitle = styled.h1`
  color: #17224d;
  margin-bottom: 20px;
`;

export const WorkIntroductionText = styled.p`
  color: #17224d;
`;

export const WorkIntroductionButton = styled.div`
  background-color: #3393f0;
  color: white;
  border-radius: 24px;
  padding: 10px;
  width: 33%;
  cursor: pointer;
  margin: 20px auto 0;
`;

export const WorkCardsContainer = styled.div`
  margin-top: 60px;
  background-image: url("/assets/bg.png");
  background-color: #edf1fc;
  width: 100%;
  padding-bottom: 60px;
`;

export const WorkCardsTextContainer = styled.div`
  text-align: center;
  margin-top: 60px;
`;

export const WorkCardsCardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 40px;
  max-width: 1200px;
  margin: 20px auto;

  @media (max-width: 1337px) {
    flex-direction: column;
  }
`;

export const WorkCard = styled.div`
  width: 33%;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 36px;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  min-height: 380px;
  transition: transform 1s ease, background-color 1s ease;

  @media (max-width: 1337px) {
    width: 80%;
    margin: 20px auto;
    min-height: 280px;
  }

  &:hover {
    transform: translateY(-4%);
    background-color: #3393f0;

    h3,
    p {
      color: white;
    }

    div {
      background-color: white;
      color: #17224d;
    }
  }
`;

export const WorkCardTitle = styled.h3`
  margin-bottom: 20px;
  color: #17224d;
`;

export const WorkCardIcon = styled(FontAwesomeIcon)`
  font-size: 38px;
  margin-top: 10px;
  margin-bottom: 20px;
  width: 40px;
  color: #3393f0;
  border-radius: 50%;
  background-color: #edf1fc;
  padding: 12px;
`;

export const WorkCardText = styled.p`
  flex-grow: 1;
  text-align: center;
  font-size: 12px;
  color: #17224d;
`;

export const WorkCardReadMoreButton = styled.div`
  background-color: #3393f0;
  color: white;
  padding: 10px 28px;
  border-radius: 24px;
  text-align: center;
  margin-top: 15px;
  cursor: pointer;
  font-size: 14px;
`;

export const WorkWhyContainer = styled.div`
  width: 100%;
  background-color: #17224d;
  height: 100%;
`;

export const WorkWhySection = styled.div`
  max-width: 1200px;
  margin: 20px auto;
  display: flex;
  margin-top: 60px;

  @media (max-width: 1335px) {
    flex-direction: column;
  }
`;

export const WorkWhyImage = styled.img`
  width: 90%;
  border-radius: 24px;
  box-shadow: 2px 1px 4px 8px rgba(0, 0, 0, 0.2);

  @media (max-width: 1337px) {
    margin-left: 20%;
    margin-right: 20%;
    width: 60%;
  }
`;

export const WorkWhyTextContainer = styled.div`
  @media (max-width: 1337px) {
    margin-left: 20%;
    margin-right: 20%;
    width: 60%;
  }
`;

export const WorkWhyTextHeader = styled.div`
  color: #3393f0;
  letter-spacing: 2px;
  font-size: 14px;
  margin-bottom: 20px;

  @media (max-width: 1337px) {
    margin-top: 40px;
    text-align: center;
  }
`;

export const WorkWhyDescription = styled.div`
  color: white;
  margin-bottom: 20px;

  @media (max-width: 1337px) {
    text-align: center;
  }
`;

export const WorkWhyIcon = styled(FontAwesomeIcon)`
  color: white;
  font-size: 24px;
  width: 25px;
  color: #3393f0;
  border-radius: 50%;
  background-color: #edf1fc;
  padding: 12px;

  @media (max-width: 600px) {
    margin: 0 auto;
    margin-top: 20px;
  }
`;

export const WorkWhyCardSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WorkWhyCard = styled.div`
  padding: 20px;
  display: flex;

  @media (max-width: 600px) {
    flex-direction: column;
    padding: 0;
  }
`;

export const WorkWhyCardTextContainer = styled.div`
  margin-left: 20px;

  @media (max-width: 600px) {
    margin-left: 0;
  }
`;

export const WorkWhyCardTextTitle = styled.h3`
  color: #3393f0;

  @media (max-width: 600px) {
    margin-top: 20px;
    text-align: center;
  }
`;

export const WorkWhyCardText = styled.p`
  color: white;
  font-size: 14px;
  margin-top: 10px;

  @media (max-width: 600px) {
    text-align: center;
  }
`;
